export default __webpack_public_path__ + "static/media/office.6ea18c90.jpg";